export enum FulfilmentStatusEnum {
  completed = 'completed',
  progress = 'progress',
  none = 'none',
  checkMailbox = 'checkMailbox',
  optional = 'optional',
}
